import { Link } from "react-router-dom";
import { PageShell } from "@/components/PageShell";

export default function NotFoundPage() {
  return (
    <PageShell>
      <section data-testid="not-found-page" className="flex min-h-[55vh] flex-col items-center justify-center bg-ivory px-5 py-24 text-center">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-cognac">Erreur 404</p>
        <h1 className="mt-4 font-display text-3xl font-medium text-navy sm:text-4xl">Cette page n'existe pas.</h1>
        <Link
          data-testid="not-found-home-link"
          to="/"
          className="mt-8 rounded-full bg-navy px-7 py-3.5 text-sm font-bold text-white transition-colors duration-300 hover:bg-cognac"
        >
          Retour à l'accueil
        </Link>
      </section>
    </PageShell>
  );
}
